import { z } from 'zod'
import { ADD_FOCUS_FIELD_ORDER } from '../constants'

/** Angular add form: property_id, company_id, prospect_id — required */
export const yardiInviteAddSchema = z.object({
  company_id: z.string().min(1, 'Company Selection is required.'),
  property_id: z.string().min(1, 'Property Selection is required.'),
  prospect_id: z.string().min(1, 'Prospect ID is required.'),
})

/**
 * Angular checkValidation(form, true) iteration order on FormGroup:
 * property_id, company_id, prospect_id
 */
export function firstAddFormErrorMessage(errors: z.ZodError<unknown>): string {
  const flat = errors.flatten().fieldErrors as Partial<
    Record<'property_id' | 'company_id' | 'prospect_id', string[] | undefined>
  >
  for (const key of ['property_id', 'company_id', 'prospect_id'] as const) {
    const msg = flat[key]?.[0]
    if (msg) return msg
  }
  return errors.issues[0]?.message ?? 'Validation failed'
}

export function focusFirstInvalidYardiAddField(errors: z.ZodError<unknown>): void {
  const flat = errors.flatten().fieldErrors as Partial<
    Record<(typeof ADD_FOCUS_FIELD_ORDER)[number], string[] | undefined>
  >
  window.requestAnimationFrame(() => {
    for (const key of ADD_FOCUS_FIELD_ORDER) {
      if (!flat[key]?.length) continue
      const selector =
        key === 'company_id'
          ? '[data-testid="yardi-invite-add-company"]'
          : key === 'property_id'
            ? '[data-testid="yardi-invite-add-property"]'
            : '#prospect_id'
      const el = document.querySelector(selector) as HTMLElement | null
      if (el) {
        el.focus()
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        return
      }
    }
  })
}

export const yardiGuestSearchSchema = z.object({
  org_id: z.string().optional(),
  company_id: z
    .string()
    .min(1, 'Company is required.')
    .regex(/^\d+$/, 'Company is required.'),
  property_id: z
    .string()
    .min(1, 'Property is required.')
    .regex(/^\d+$/, 'Property is required.'),
  first_name: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'First Name Must be 2 characters long.',
  }),
  last_name: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'Last Name Must be 2 characters long.',
  }),
  email_address: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'Email Must be 2 characters long.',
  }),
  phone_number: z.string().optional().refine((v) => !v || v.length >= 7, {
    message: 'Phone Number Must be 7 characters long.',
  }),
  /** Stored as YYYY-MM-DD (DatePicker / native date; API same as Angular) */
  date_of_birth: z.string().optional(),
  third_party_id: z.string().optional(),
  federal_id: z.string().optional(),
  join_filter_items_with_and: z.boolean(),
})
